export const GET_INDEX_REQUEST = "GET_INDEX_REQUEST"
export const GET_INDEX_SUCCESS = "GET_INDEX_SUCCESS"
export const GET_INDEX_FAIL = "GET_INDEX_FAIL"
